/**
 * Trigger a browser download for a given URL.
 * The signed URL carries Content-Disposition: attachment so clicking a link
 * initiates a download instead of navigating.
 */
export function triggerBrowserDownload(url: string, suggestedFilename?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (suggestedFilename) {
    a.download = suggestedFilename;
  }
  a.rel = 'noopener';
  a.target = '_self';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
